var plugin_rtlignore_default = {
  "alignLeft": "vC0wI",
  "textWrapNowrap": "pjU3c",
  "alignRight": "nZ0XC",
  "alignCenter": "M9Otd",
  "sizeFullWidth": "VVkKW",
  "renderedInTable": "nILKs",
  "sizeOriginal": "_0VIJe",
  "sizeContent": "xf3Lh",
  "sizeSmall": "Nv24-",
  "sizeSmallCenter": "QW5ND",
  "flex": "oA14Y",
  "atomic": "giltF",
  "embed": "hgBlo",
  "horizontalScrollbar": "E4AE-",
  "pluginContainerMobile": "vHsqy"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
